import React from "react";
import { AlertTriangle } from "lucide-react";

type DangerZoneCardProps = {
  children: React.ReactNode;
};

/**
 * Carte « zone dangereuse » — thème sombre, accents rouges uniquement (pas de vert).
 */
export default function DangerZoneCard({ children }: DangerZoneCardProps): React.JSX.Element {
  return (
    <section
      className="rounded-2xl border border-rose-500/35 bg-slate-950/90 p-5 shadow-xl ring-1 ring-rose-500/10 transition-colors hover:border-rose-500/50 hover:ring-rose-500/20"
      aria-labelledby="danger-zone-heading"
    >
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-500/15 text-rose-400 ring-1 ring-rose-500/30">
          <AlertTriangle className="h-5 w-5" strokeWidth={1.75} aria-hidden />
        </span>
        <div className="min-w-0 flex-1 space-y-1">
          <h2 id="danger-zone-heading" className="text-base font-semibold text-rose-100">
            Zone dangereuse
          </h2>
          <p className="text-xs leading-relaxed text-slate-400">
            Actions irréversibles réservées à l’administrateur. Toute opération ci-dessous est tracée et peut
            impacter les données métier de test (environnements de qualification ou démonstration).
          </p>
        </div>
      </div>
      <div className="mt-5 border-t border-rose-500/15 pt-5">{children}</div>
    </section>
  );
}
